import React from "react";
import PropTypes from "prop-types";
import AppModal from "./AppModal";


// eslint-disable-next-line react/prefer-stateless-function
function RedirectModal({
  redirectURL,
  redirectTitle,
  redirectBody,
  redirectButtonText,
  modalId,
  isOpen,
  onRequestClose,
  onStateChanged,
}) {

  // eslint-disable-next-line class-methods-use-this
  const navigateToExternalURL = () => {
    window.location.href = redirectURL;
  }

  return (
    <AppModal
      id={modalId}
      isOpen={isOpen}
      onStateChanged={onStateChanged}
      title={redirectTitle}
      body={redirectBody}
      primaryActionText={redirectButtonText}
      onPrimaryAction={navigateToExternalURL}
      secondaryActionText="Cancel"
      onSecondaryAction={onRequestClose}
    />
  );
}

RedirectModal.propTypes ={
  redirectURL: PropTypes.string.isRequired,
  redirectTitle: PropTypes.string.isRequired,
  redirectBody: PropTypes.string.isRequired,
  redirectButtonText: PropTypes.string.isRequired,
  modalId: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onRequestClose: PropTypes.func.isRequired,
  onStateChanged: PropTypes.func,
}

RedirectModal.defaultProps = {
  onStateChanged: undefined,
};

export default RedirectModal;
